/* Current Shopify images are authoritative. Legacy source-photo overrides and crop frames are retired. */
window.bellaVariantImages={};
window.bellaVariantImageFrames={};
window.bellaVariantReferenceIds={};
// Callers pass the current variant image, falling back to the current product image.
window.bellaVariantMediaFor=function(id,fallback){
 return {src:fallback||'',imageId:null,frame:null,note:'',mapped:false};
};
window.bellaVariantFrameStyles=function(){
 return {viewport:'',image:''};
};
